import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { MeterBarTone } from './MeterBar';

const toneColor: Record<MeterBarTone, string> = {
  success: theme.color.success,
  warning: theme.color.warning,
  danger: theme.color.danger,
};

export const meterBarStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.text};
`;

/* 80×6 고정 크기 트랙. */
export const trackStyle = css`
  width: 80px;
  height: 6px;
  border-radius: ${theme.radius.pill}px;
  background: ${theme.color.border};
  overflow: hidden;
`;

export const fillStyle = (tone: MeterBarTone) => css`
  display: block;
  height: 100%;
  background: ${toneColor[tone]};
`;
